import React from 'react';
import { Box, Typography, Grid, Card, CardContent, TextField, FormControl, Select, MenuItem } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female';
import { regions, age as ageOptions } from '../data/formData';

const PersonalInfoStep = ({ 
  clientType, setClientType,
  gender, setGender,
  age, setAge,
  region, setRegion,
  errors,
  themeColors 
}) => {
  return (
    <Box>
      <Typography sx={{fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, fontWeight: 700, textAlign: 'center'}} gutterBottom>
        Client Type
      </Typography>
      <Grid container sx={{pl: { xs: 2, sm: 8, md: 15 }, pr: { xs: 2, sm: 8, md: 15 }}} spacing={2} justifyContent="center" mb={2}>
        <Grid item xs={12} sm={4}>
          <Card 
            sx={{ 
              textAlign: 'center', 
              cursor: 'pointer',
              border: clientType === 'Citizen' ? `2px solid ${themeColors.primary}` : `1px solid ${themeColors.borderColor}`,
              backgroundColor: clientType === 'Citizen' ? themeColors.bgLight : 'white'
            }}
            onClick={() => setClientType('Citizen')}
          >
            <CardContent>
              <Box sx={{ color: themeColors.primary, fontSize: { xs: 24, sm: 30 } }}><PersonIcon fontSize='large'/></Box>
              <Typography color={themeColors.primary} fontWeight={500}>Citizen</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card 
            sx={{ 
              textAlign: 'center', 
              cursor: 'pointer',
              border: clientType === 'Business' ? `2px solid ${themeColors.primary}` : `1px solid ${themeColors.borderColor}`,
              backgroundColor: clientType === 'Business' ? themeColors.bgLight : 'white'
            }}
            onClick={() => setClientType('Business')}
          >
            <CardContent>
              <Box sx={{ color: themeColors.primary, fontSize: { xs: 24, sm: 30 } }}><WorkIcon fontSize='large'/></Box>
              <Typography color={themeColors.primary} fontWeight={500}>Business</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Card 
            sx={{ 
              textAlign: 'center', 
              cursor: 'pointer',
              border: clientType === 'Government' ? `2px solid ${themeColors.primary}` : `1px solid ${themeColors.borderColor}`,
              backgroundColor: clientType === 'Government' ? themeColors.bgLight : 'white'
            }}
            onClick={() => setClientType('Government')}
          >
            <CardContent>
              <Box sx={{ color: themeColors.primary, fontSize: { xs: 24, sm: 30 } }}><AccountBalanceIcon fontSize='large' /></Box>
              <Typography color={themeColors.primary} fontWeight={500}>Government</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography sx={{fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, fontWeight: 700, textAlign: 'center'}} gutterBottom>
        Sex
      </Typography>
      <Grid container sx={{pl: { xs: 4, sm: 12, md: 20 }, pr: { xs: 4, sm: 12, md: 20 }}} spacing={2} justifyContent="center" mb={2}>
        <Grid item xs={12} sm={6}>
          <Card 
            sx={{ 
              textAlign: 'center', 
              cursor: 'pointer',
              border: gender === 'Male' ? `2px solid ${themeColors.primary}` : `1px solid ${themeColors.borderColor}`,
              backgroundColor: gender === 'Male' ? themeColors.bgLight : 'white'
            }}
            onClick={() => setGender('Male')}
          >
            <CardContent>
              <Box sx={{ color: themeColors.primary, fontSize: { xs: 24, sm: 30 } }}><MaleIcon fontSize='large' /></Box>
              <Typography color={themeColors.primary} fontWeight={500}>Male</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card 
            sx={{ 
              textAlign: 'center', 
              cursor: 'pointer',
              border: gender === 'Female' ? `2px solid ${themeColors.primary}` : `1px solid ${themeColors.borderColor}`,
              backgroundColor: gender === 'Female' ? themeColors.bgLight : 'white'
            }}
            onClick={() => setGender('Female')}
          >
            <CardContent>
              <Box sx={{ color: themeColors.primary, fontSize: { xs: 24, sm: 30 } }}><FemaleIcon fontSize='large'/></Box>
              <Typography color={themeColors.primary} fontWeight={500}>Female</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography sx={{fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, fontWeight: 700, textAlign: 'center'}} gutterBottom>
        Age
      </Typography>
      <FormControl fullWidth sx={{ pl: { xs: 4, sm: 12, md: 20 }, pr: { xs: 4, sm: 12, md: 20 }, mb: 3 }}>
        <Select
          value={age}
          onChange={(e) => setAge(e.target.value)}
          displayEmpty
          renderValue={
            age !== "" ? undefined : () => "Select your Age"
          }
          sx={{
            '&.MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: themeColors.primary,
              },
            },
          }}
          error={errors?.age}
        >
          {ageOptions.map((ageOption) => (
            <MenuItem key={ageOption.value} value={ageOption.value}>
              {ageOption.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography sx={{fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, fontWeight: 700, textAlign: 'center'}} gutterBottom>
        Region of Residence
      </Typography>
      <FormControl fullWidth sx={{ pl: { xs: 4, sm: 12, md: 20 }, pr: { xs: 4, sm: 12, md: 20 }, mb: 3 }}>
        <Select
          value={region}
          onChange={(e) => setRegion(e.target.value)}
          displayEmpty
          renderValue={
            region !== "" ? undefined : () => "Select your region"
          }
          sx={{
            '&.MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: themeColors.primary,
              },
            },
          }}
          error={errors?.region}
        >
          {regions.map((regionOption) => (
            <MenuItem key={regionOption.value} value={regionOption.value}>
              {regionOption.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PersonalInfoStep;